import './jquery'
import './bootstrap-datepicker.min.js'
import './locales/bootstrap-datepicker.el.min.js'
import './jquery.touchSwipe.min.js'
import './moment'
import './datepicker-in-fullscreen.js'

export default {
  created: function (el, binding, vnode, prevVnode) {
    let options;
    let datepickerOptions;

    const defaults = {
      format: 'DD MMMM, YYYY',
      fakeInput: false,
      datepicker: {
        todayHighlight: true,
        weekStart: 1,
      }
    }

    if (binding.value) {
      options = {
        ...defaults,
        ...defaults.datepicker,
        ...binding.value,
      }

      datepickerOptions = {
        ...defaults.datepicker,
        ...binding.value.datepicker,
      }
    } else {
      options = defaults;
      datepickerOptions = defaults.datepicker
    }

    var startDateOption = -Infinity;
    var endDateOption = Infinity;
    var disabledDates = [];
    if (typeof datepickerOptions.startDate != 'undefined' && datepickerOptions.startDate != '') {
      startDateOption = new Date(datepickerOptions.startDate);
    }

    if (typeof datepickerOptions.endDate != 'undefined' && datepickerOptions.endDate != '') {
      endDateOption = new Date(datepickerOptions.endDate);
    }

    if (typeof options.datesDisabled != 'undefined') {
      disabledDates = options.datesDisabled;
    }

    var defaultViewDate = new Date();
    if (typeof options.datepicker.defaultViewDate != 'undefined' && options.datepicker.defaultViewDate != '') {
      defaultViewDate = new Date(options.datepicker.defaultViewDate);
    }

    $(el).datepickerInFullscreen({
      touchSwipe: options.touchSwipe,
      effect: options.effect, // 1 up to 16
      blockScroll: options.blockScroll,
      closeOnChange: options.closeOnChange,
      format: options.format,
      additionalTarget: options.additionalTarget,
      additionalTargetFormat: options.additionalTargetFormat,
      fakeInput: options.fakeInput,
      fakeInputFormat: options.fakeInputFormat,
      todayWord: options.todayWord,
      clearWord: options.clearWord,
      closeWord: options.closeWord,
      template: options.showButtons ? `<div class="datepicker-in-fullscreen-modal">
                  <div class="datepicker-in-fullscreen-content">
                    <div class="datepicker-in-fullscreen"></div>
                    <div class="datepicker-in-fullscreen-controls">
                      <a class="dpifs-today">{{today}}</a>
                      <a class="dpifs-clear">{{clear}}</a>
                      <a class="dpifs-close">{{close}}</a>
                    </div>
                  </div>
                </div>
                <div class="datepicker-in-fullscreen-background"></div>` :
        `<div class="datepicker-in-fullscreen-modal">
                  <div class="datepicker-in-fullscreen-content">
                    <div class="datepicker-in-fullscreen"></div>
                  </div>
                </div>
                <div class="datepicker-in-fullscreen-background"></div>`,
      datepicker: {
        calendarWeeks: datepickerOptions.calendarWeeks,
        datesDisabled: disabledDates,
        daysOfWeekDisabled: datepickerOptions.daysOfWeekDisabled,
        daysOfWeekHighlighted: datepickerOptions.daysOfWeekHighlighted,
        startDate: startDateOption,
        endDate: endDateOption,
        maxViewMode: 2,
        minViewMode: datepickerOptions.minViewMode,
        startView: datepickerOptions.startView, //0 as “days” or “month”, 1 as “months” or “year”, 2 as “years” or “decade”, 3 as “decades” or “century”, and 4 as “centuries” or “millenium”
        language: datepickerOptions.language,
        templates: {
          leftArrow: "«",
          rightArrow: "»"
        },
        title: "",
        todayHighlight: false, // datepickerOptions.todayHighlight,
        weekStart: datepickerOptions.weekStart,
        defaultViewDate: defaultViewDate,
      },
      beforeOpen: function (modal, settings) {
        el.dispatchEvent(new Event('before-open'))
      },
      beforeClose: function (modal, settings) {
        el.dispatchEvent(new Event('before-close'))
      },
      onChange: function (modal, settings) {
        el.dispatchEvent(new Event('input'))
      }
    })
  },
}